import {Button} from '@chakra-ui/react';
import {useInViewRef, useTranslation} from 'hooks';
import {FC, useEffect} from 'react';

interface IProps {
  fetchNextPage: () => void;
  isFetchingNextPage: boolean;
  providerPageCount?: number;
}

export const InfinityScrollButton: FC<IProps> = ({fetchNextPage, isFetchingNextPage, providerPageCount}) => {
  const [buttonRef, inView] = useInViewRef();
  const {t} = useTranslation();

  useEffect(() => {
    if (providerPageCount && inView && providerPageCount > 1) {
      fetchNextPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView]);

  return (
    <>
      <Button
        ref={buttonRef}
        variant="outline"
        onClick={() => fetchNextPage()}
        mx="auto"
        isLoading={isFetchingNextPage}
        display="flex"
        borderWidth={1.5}
        w="250px"
      >
        {t('SHOW_MORE_PROVIDERS')}...
      </Button>
    </>
  );
};
